window.cartData = {};
const updateCartData = (url, donNotCheckUrl = false) => {
    if (
        donNotCheckUrl ||
        (url?.includes("/cart/change") ||
            (url?.includes("/cart") && !url?.includes("/cart.json")) ||
            url?.includes("/cart/update") ||
            url?.includes("/cart/add") ||
            url?.includes("/cart/clear"))
    ) {
        console.log("Updating cart data from:", url);
        fetch(window.location.origin + "/cart.json")
            .then(response => response.json())
            .then(data => {
                window.cartData = data;
            });
    }
}
updateCartData("", true);
function initializeHttpObserver() {
    const originalFetch = window.fetch;
    const originalSend = XMLHttpRequest.prototype.send;

    window.fetch = async (...args) => {
        const url = args[0];
        // console.log("my url", url, args)
        return originalFetch(...args).then((res) => {
            updateCartData(url);
            return res;
        })
    };

    window.XMLHttpRequest.prototype.send = function (body) {
        const url = this._url;
        // console.log("my url 2", url, this)
        this.addEventListener('loadend', () => {
            updateCartData(url)
        });
        return originalSend.call(this, body)
    };
}
initializeHttpObserver()

const tinCandleVariantIds = [
    "46661453971730",
    "55158998139255",
    "55449199346039",
    "55227478081911",
    "55350509044087",
    "50227855524114",
    "55872176030071",
    "50229973287186",
    "50229967421714",
    "50229993996562",
    "54847525224823",
    "50229991506194",
    "49344188383506",
    "49130176119058",
    "54899782844791",
    "50229847425298",
    "55122205180279",
    "50229974827282",
    "55220060619127",
    "46661471174930"
];

const handleCheckoutSubmit = (e) => {
    document.addEventListener("submit", function (e) {
        if (e.target && (e.target.closest('#CartDrawer-Form') || e.target.closest("#cart") || e.target.closest("form[action='/cart']"))) {
            const lineItems = window.cartData?.items;
            let qty = 0;
            // console.log("Line items:", lineItems);
            lineItems?.filter(item => {
                let title = item.title.toLowerCase();
                return tinCandleVariantIds.includes(item.variant_id.toString()) || (!title.includes("build your own") && (title.includes('tin') || title.includes('90g')));
            })?.forEach(item => {
                qty += item.quantity;
            });

            if (qty > 0 && qty === 1) {
                e.preventDefault();
                e.stopPropagation();

                document.querySelector("#custom-error")?.remove();
                // Create custom error message element
                const errorDiv = document.createElement('div');
                errorDiv.id = "custom-error";
                errorDiv.style.cssText = `
                    background: rgb(255, 68, 68);
                    color: white;
                    padding: 3px 9px;
                    border-radius: 5px;
                    font-family: Arial, sans-serif;
                    font-size: 14px;
                    z-index: 9999;
                    box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 6px;
                    z-index: 5;
                    position: sticky;
                    top: 0;
                    width: 100%;
                    font-size: 13px;
                    line-height: 1.2;
                    margin-bottom: 5px;
                    color: black;
                    font-weight: bold;
                    margin-bottom: 5px;
                `;
                errorDiv.textContent = "Tin candles are sold in sets of 2 – add 1 more to continue.";
                if(e.target.closest('#CartDrawer-Form')) {
                    (document.querySelector("cart-drawer-items") ?? document.body).prepend(errorDiv);
                } else if(e.target.closest("#cart")) {
                    (document.querySelector(`#cart .js-contents`) ?? document.body).prepend(errorDiv);
                }

                // Remove message after 5 seconds
                setTimeout(() => {
                    if (errorDiv.parentNode) {
                        errorDiv.parentNode.removeChild(errorDiv);
                    }
                }, 5000);

                return false;
            }
        }
    });
}
handleCheckoutSubmit()